import type { NFT } from "types";
import veUSD from "libs/tokens/img/veUSD.svg";
import veETH from "libs/tokens/img/veETH.svg";

export const venfts: NFT[] = [
  {
    address: "0x0966cae7338518961c2d35493d3eb481a75bb86b",
    symbol: "veUSD",
    asset: veUSD,
  },
  {
    address: "0x1Ec2b9a77A7226ACD457954820197F89B3E3a578",
    symbol: "veETH",
    asset: veETH,
  },
];
